<template>
  <div class="index">
    <el-scrollbar>
      <div class="task">
        <el-card header="送检订单待处理任务">
          <el-button class="task-btn" @click="waitAuditHandle">
            <div class="task-item">
              <i class="el-icon-finished"></i>
              <p>待审核： <b>{{waitAudit.value}}</b></p>
            </div>
          </el-button>
          <el-button class="task-btn" @click="waitReceiptHandle">
            <div class="task-item">
              <i class="el-icon-box"></i>
              <p>待签收： <b>{{waitReceipt.value}}</b></p>
            </div>
          </el-button>
          <el-button class="task-btn" @click="waitDetectionHandle">
            <div class="task-item">
              <i class="el-icon-edit-outline"></i>
              <p>待提交检测： <b>{{waitDetection.value}}</b></p>
            </div>
          </el-button>
          <el-button class="task-btn" @click="waitDetectionCompleteHandle">
            <div class="task-item">
              <i class="el-icon-tickets"></i>
              <p>待确认检测完成： <b>{{waitDetectionComplete.value}}</b></p>
            </div>
          </el-button>
          <el-button class="task-btn" @click="waitMoneyHandle">
            <div class="task-item">
              <i class="el-icon-document-checked"></i>
              <p>待确认收款： <b>{{waitMoney.value}}</b></p>
            </div>
          </el-button>
          <el-button class="task-btn" @click="waitReturnHandle">
            <div class="task-item">
              <i class="el-icon-truck"></i>
              <p>待返货： <b>{{waitReturn.value}}</b></p>
            </div>
          </el-button>
        </el-card>
      </div>
      <div class="count">
        <el-card header="用户数量">
          <p class="count-info">{{totalCount.user.total}}</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日新增</span>
            <span>{{totalCount.userNew.total}}</span>
          </div>
        </el-card>
        <el-card header="商品数量">
          <p class="count-info">{{totalCount.product.total}}</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日上架</span>
            <span>{{totalCount.productNew.total}}</span>
          </div>
        </el-card>
        <el-card header="商城订单数量">
          <p class="count-info">{{totalCount.productOrder.total}}</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日新增</span>
            <span>{{totalCount.productOrderNew.total}}</span>
          </div>
        </el-card>
        <el-card header="送检订单数量">
          <p class="count-info">{{totalCount.inspect.total}}</p>
          <el-divider />
          <div class="count-info-down">
            <span>今日新增</span>
            <span>{{totalCount.inspectNew.total}}</span>
          </div>
        </el-card>
      </div>
      <div class="ins">
        <el-card header="送检订单统计">
          <div class="ins-content">
            <div id="ins-state" style="height: 480px;width:50%"></div>
            <div id="ins-count" style="height: 480px;width:50%"></div>
          </div>
        </el-card>
      </div>
    </el-scrollbar>
  </div>

</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import * as echarts from "echarts";
import { ReportService } from "@/script/apps/report/service/ReportService";
import { ViewUtil } from "@/script/core/util/ViewUtil";
import {
  OrderCountReport,
  OrderStatesReport,
  TotalCountReport,
} from "@/script/apps/report/entity/ReportEntity";

@Options({})
export default class OrderDetail extends Vue {
  private totalCount: TotalCountReport = {
    user: { type: "", total: 0 },
    product: { type: "", total: 0 },
    productOrder: { type: "", total: 0 },
    inspect: { type: "", total: 0 },
    userNew: { type: "", total: 0 },
    productNew: { type: "", total: 0 },
    productOrderNew: { type: "", total: 0 },
    inspectNew: { type: "", total: 0 },
  };

  private waitAudit = { name: "待审核", value: 0 };
  private waitReceipt = { name: "待签收：", value: 0 };
  private waitDetection = { name: "待提交检测", value: 0 };
  private waitDetectionComplete = { name: "待确认检测完成", value: 0 };
  private waitMoney = { name: "待确认收款", value: 0 };
  private waitReturn = { name: "待返货", value: 0 };

  private chartState: any;
  private chartOrderDay: any;

  activated() {
    this.loadOrderStates();
  }

  waitAuditHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "1" });
  }

  waitReceiptHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "2" });
  }

  waitDetectionHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "5" });
  }

  waitDetectionCompleteHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "7" });
  }

  waitMoneyHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "8" });
  }

  waitReturnHandle() {
    ViewUtil.toListView("/ins/inspect/list", "送检订单", { state: "9" });
  }

  loadOrderStates() {
    const reportService = new ReportService();
    reportService.loadOrderStates((report: OrderStatesReport) => {
      this.setChartState(report);

      this.waitAudit.value = this.getStateCount(report, "1");
      this.waitReceipt.value =
        this.getStateCount(report, "3") + this.getStateCount(report, "4");
      this.waitDetection.value = this.getStateCount(report, "5");
      this.waitDetectionComplete.value = this.getStateCount(report, "7");
      this.waitMoney.value = this.getStateCount(report, "8");
      this.waitReturn.value = this.getStateCount(report, "9");
    });

    reportService.loadOrderDayCount((report: OrderCountReport) => {
      this.setChartOrderDay(report);
    });

    reportService.loadTotalCount((report: TotalCountReport) => {
      this.totalCount = report;
    });
  }

  setChartState(report: OrderStatesReport) {
    if (!this.chartState) {
      var chartDom = document.getElementById("ins-state")!;
      this.chartState = echarts.init(chartDom);
    }

    type EChartsOption = echarts.EChartsOption;
    var option: EChartsOption;

    option = {
      title: {
        text: "订单状态统计",
        subtext: "不包含已完成和已取消",
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      series: [
        {
          name: "状态数量",
          type: "pie",
          radius: "50%",
          data: [
            { value: this.getStateCount(report, "1"), name: "已提交待邮寄" },
            { value: this.getStateCount(report, "3"), name: "已审核待邮寄" },
            { value: this.getStateCount(report, "4"), name: "运送中" },
            { value: this.getStateCount(report, "5"), name: "已签收待送检" },
            { value: this.getStateCount(report, "6"), name: "检测中" },
            { value: this.getStateCount(report, "7"), name: "检测完成" },
            { value: this.getStateCount(report, "8"), name: "检测完成待付款" },
            { value: this.getStateCount(report, "9"), name: "付款完成待寄回" },
            { value: this.getStateCount(report, "10"), name: "已寄回" },
          ],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
    option && this.chartState.setOption(option);
  }

  setChartOrderDay(report: OrderCountReport) {
    if (!this.chartOrderDay) {
      var chartDom2 = document.getElementById("ins-count")!;
      this.chartOrderDay = echarts.init(chartDom2);
    }

    var xdata: any[] = [];
    var dayDatas: any[] = [];
    report.orderDayCounts.forEach((item) => {
      xdata.push(item.name);
      dayDatas.push(item.count);
    });

    type EChartsOption = echarts.EChartsOption;
    var option: EChartsOption;

    option = {
      title: {
        text: "本月订单数量",
        left: "center",
      },
      xAxis: {
        type: "category",
        data: xdata,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          data: dayDatas,
          type: "line",
        },
      ],
    };
    option && this.chartOrderDay.setOption(option);
  }

  getStateCount(report: OrderStatesReport, state: string) {
    let count = 0;
    report.orderStates.forEach((item) => {
      if (item.state === state) {
        count = item.count;
      }
    });
    return count;
  }
}
</script>

<style lang="scss">
.index {
  height: calc(100vh - 180px);
}
.count {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 30px;
}
.ins {
  margin-top: 20px;
}
.ins-content {
  display: flex;
}

.count-info {
  font-size: 24px;
  font-weight: bold;
  line-height: 30px;
  margin: 0;
}

.count-info-down {
  display: flex;
  justify-content: space-between;
}

.task-item i {
  color: black;
  font-size: 30px;
}

.task-item p {
  color: black;
}
</style>
